import { FUTURO_TYPEFACES as F } from '@ordermentum/ui-shared/foundations/font';
import S from '@ordermentum/ui-shared/foundations/size';
import { genThemedStyled } from '@ordermentum/ui-shared/utilities/theme';
import { ColorCodes } from '@ordermentum/ui-shared/foundations/color';

type themeStyles = {
  headerColor: ColorCodes;
  descriptionColor: ColorCodes;
  helpHeaderColor: ColorCodes;
  helpDescriptionColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

export const MFAContainer = ThemeStyled.div({
  flexBasis: '60%',
  display: 'flex',
  flexDirection: 'column',
});

export const MFAHeader = ThemeStyled.h3(p => ({
  color: p.theme.headerColor,
  marginBottom: S.XXS,
  ...F.H3,
}));

export const MFADescription = ThemeStyled.p(p => ({
  color: p.theme.descriptionColor,
  marginBottom: S.XL,
  ...F.BODY,
}));

export const OTPWrapper = ThemeStyled.div({
  display: 'inline-block',
  marginBottom: S.XL,
});

export const MFAHelpHeader = ThemeStyled.h5(p => ({
  color: p.theme.helpHeaderColor,
  marginRight: S.XS,
  ...F.H5,
}));

export const MFAHelpDescription = ThemeStyled.p(p => ({
  color: p.theme.helpDescriptionColor,
  marginTop: S.XXS,
  marginBottom: S.XXXL,
  ...F.BODY,
}));

export const SpinnerWrapper = ThemeStyled.div({
  display: 'inline-block',
  marginBottom: S.XL,
});

export const MFAResendContainer = ThemeStyled.div({
  marginTop: S.XL,
  marginBottom: S.XL,
});

export const MFAResendText = ThemeStyled.p(p => ({
  color: p.theme.descriptionColor,
  ...F.BODY,
}));

export const MFAResentTextBold = ThemeStyled.span(p => ({
  color: p.theme.headerColor,
  ...F.BUTTON,
}));
